import React from 'react';
import classes from './ProjectListItem.module.scss';
import { Card, CardBody, CardFooter, CardSubtitle, CardText, CardTitle, Row } from 'reactstrap';
import { Badge } from '@core/frontend/ui';
import { determineVotes, isAchievementUnlocked } from '@core/shared';
import ProgressBar from '../../../components/UI/ProgressBar/ProgressBar';
import thumbnailPlaceholder from '../../../assets/images/project-thumbnail-placeholder.webp';
import { achievementBadgeAssets } from '../../../shared/badgeAssets.js';

/**
 * Listeneintrag der Projektliste im Foerdertopf-Modell: Karte mit Thumbnail,
 * Kurzbeschreibung, Foerderstand und Abzeichen-Reihe (Intended Difference #2).
 *
 * Der Kern rendert den Link und die fuer Screenreader sichtbare Zusammenfassung; dieser
 * Eintrag liefert nur das Kartenmarkup und bekommt dafuer den Obermengen-Prop-Satz aus
 * `ProjectList`. Der Foerderstand (`ProgressBar`) und die Abzeichen-Grafiken bleiben App-Code.
 */
const ProjectListItem = (props) => {
    const { project, phases, fundingStages, projectBalance, projectPageConfig, achievements } = props;
    const { defaultThumbnailUrl, thresholdIconName, thresholdIconActiveName, progressBarSuccessColor } =
        projectPageConfig || {};
    const unlockedAchievements = Array.isArray(achievements) ? achievements : [];
    const gallery = project.projectGallery || [];
    const imageSrc = (gallery.length > 0 ? gallery[0].url : defaultThumbnailUrl) || thumbnailPlaceholder;
    const voteCount = determineVotes(project.voteCount, phases);

    return (
        <div className="h-100 w-100" aria-hidden={true}>
            <Card className="h-100 anl__project-list--item shadow-sm">
                <div className={classes.CardImageContainer}>
                    <img
                        className={classes.CardImage}
                        src={imageSrc}
                        loading="lazy"
                        alt={project.contestantName || project.projectTitle || ''}
                        aria-hidden={true}
                    />
                </div>
                <CardBody className="d-flex flex-column">
                    <CardTitle tag="h2" className="h4 text-primary mb-1">
                        {project.contestantName}
                    </CardTitle>
                    {project.projectTitle ? (
                        <CardSubtitle tag="h6" className="mb-2 text-muted">
                            {project.projectTitle}
                        </CardSubtitle>
                    ) : null}
                    {project.projectShortDescription && (
                        <CardText className="text-body mb-3">{project.projectShortDescription}</CardText>
                    )}
                    <div className="mt-auto pt-2">
                        <ProgressBar
                            bubble={false}
                            projectBalance={projectBalance ?? 0}
                            voteCount={voteCount}
                            phases={phases}
                            cssClasses=""
                            fundingStages={fundingStages}
                            thresholdIconName={thresholdIconName}
                            thresholdIconActiveName={thresholdIconActiveName}
                            progressBarSuccessColor={progressBarSuccessColor}
                        />
                    </div>
                </CardBody>
                <CardFooter className={`p-0 ${classes.CardFooter}`}>
                    <Row className="m-0 top-0 justify-content-end pe-2">
                        <Badge
                            type="isReferral"
                            isAchieved={isAchievementUnlocked(unlockedAchievements, 'isReferral')}
                            isLink={false}
                            assets={achievementBadgeAssets}
                        />
                        <Badge
                            type="hasReferred"
                            isAchieved={isAchievementUnlocked(unlockedAchievements, 'hasReferred')}
                            isLink={false}
                            assets={achievementBadgeAssets}
                        />
                        <Badge
                            type="emailShares"
                            isAchieved={isAchievementUnlocked(unlockedAchievements, 'emailShares')}
                            isLink={false}
                            assets={achievementBadgeAssets}
                        />
                        <Badge
                            type="facebookShares"
                            isAchieved={isAchievementUnlocked(unlockedAchievements, 'facebookShares')}
                            isLink={false}
                            assets={achievementBadgeAssets}
                        />
                        <Badge
                            type="whatsAppShares"
                            isAchieved={isAchievementUnlocked(unlockedAchievements, 'whatsAppShares')}
                            isLink={false}
                            assets={achievementBadgeAssets}
                        />
                    </Row>
                </CardFooter>
            </Card>
        </div>
    );
};

export default ProjectListItem;
